import { useLang } from "../../context/LanguageContext";
import BookingWidget from "./BookingWidget";

/** Dedicated booking band — sits between Hero and Property so the widget never overlaps anything. */
export default function BookingBand() {
  const { t, lang } = useLang();
  return (
    <section id="booking" data-testid="booking-band" className="bg-[hsl(var(--cream))] text-[hsl(var(--foreground))] border-b border-[hsl(var(--foreground))]/8">
      <div className="container-x py-16 md:py-20">
        <div className="max-w-2xl mb-10">
          <div className="overline mb-4">{lang === "de" ? "Verfügbarkeit" : "Availability"}</div>
          <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl leading-[1.04] tracking-tight text-[hsl(var(--foreground))]">
            {lang === "de" ? "Wähle dein Refugium." : "Choose your retreat."}
          </h2>
          <p className="mt-4 text-[hsl(var(--foreground))]/85 text-sm md:text-base">
            {lang === "de"
              ? "Wähle Haus, Zeitraum und Gäste — der Preis berechnet sich automatisch nach Saison."
              : "Pick a house, dates and guests — the price updates by season."}
          </p>
        </div>
        <BookingWidget />
      </div>
    </section>
  );
}
